export const loginRes = {
  paymentAuthTitle: {
    is: 'Staðfesting greiðslu með auðkenningu',
    en: 'Confirming payment with authentication',
    pl: 'Potwierdzenie płatności za pomocą identyfikacji',
  },
  authenticate: {
    is: 'Auðkenning',
    en: 'Authentication',
    pl: 'Uwierzytelnianie',
  },
  authenticateButtonText: {
    is: 'Auðkenna',
    en: 'Authenticate',
    pl: 'Uwierzytelniać',
  },
  login: {
    is: 'Innskráning',
    en: 'Login',
    pl: 'Zaloguj się',
  },
  loginButtonText: {
    is: 'Innskrá',
    en: 'Log in',
    pl: 'Zaloguj się',
  },
  tryagain: {
    is: 'Til baka',
    en: 'Back',
    pl: 'Wróć',
  },
  loadingTitle: {
    is: 'Augnablik',
    en: 'One moment',
    pl: 'Proszę czekać',
  },
  loadingDescription: {
    is: 'Við erum að vinna úr auðkenningunni',
    en: 'We are working on authentication',
    pl: 'Trwa uwierzytelnianie',
  },
  loadingCancelDescription: {
    is: 'Hætt við auðkenningu',
    en: 'Authentication canceled',
    pl: 'Uwierzytelnianie anulowane',
  },
  auth_password: {
    is: 'Notandanafn',
    en: 'User name',
    pl: 'Imię użytkownika',
  },
  auth_pkiSim: {
    is: 'Rafræn skilríki',
    en: 'Electronic ID',
    pl: 'eID',
  },
  auth_fido: {
    is: 'Lífkenni',
    en: 'Biometric',
    pl: 'Identyfikacja biometryczna',
  },
  auth_app: {
    is: 'Landsbankaappið',
    en: 'Landsbankinn app',
    pl: 'Landsbankinn app',
  },
  auth_audkenniApp: {
    is: 'Auðkennisappið',
    en: 'Auðkenni app',
    pl: 'Auðkenni app',
  },
  authenticate_description_tpp_ais: {
    is: '{client} óskar eftir auðkenningu til að geta sótt upplýsingar',
    en: '{client} is requesting authentication to information',
  },
  authenticate_description_tpp_pis: {
    is: '{client} óskar eftir auðkenningu til staðfestingar á greiðslu',
    en: '{client} is requesting authentication for payment consent',
  },
  cancel: {
    is: 'Hætta við',
    en: 'Cancel',
    pl: 'Anuluj',
  },
  continue: {
    is: 'Áfram',
    en: 'Continue',
    pl: 'Dalej',
  },
  reject: {
    is: 'Til baka',
    en: 'Back',
    pl: 'Powrót',
  },
} as const;
